/**
 * Expanded club opening book (polyglot-style weights).
 * Source of truth for ECO names; binary packaging in /opening/club-book.bin (CDB1).
 */
import { bookCandidatesFromBin, loadClubBookBin, lookupFromBin } from './polyglotBook';

const BOOK = {
  'e2e4': { eco: 'B00', name: "King's Pawn", weight: 100 },
  'e2e4 e7e5': { eco: 'C20', name: 'Open Game', weight: 90 },
  'e2e4 e7e5 g1f3': { eco: 'C40', name: "King's Knight Opening", weight: 95 },
  'e2e4 e7e5 g1f3 b8c6': { eco: 'C44', name: "King's Knight — Two Knights path", weight: 80 },
  'e2e4 e7e5 g1f3 b8c6 f1b5': { eco: 'C60', name: 'Ruy Lopez', weight: 100 },
  'e2e4 e7e5 g1f3 b8c6 f1b5 a7a6': { eco: 'C70', name: 'Ruy Lopez — Morphy Defence', weight: 95 },
  'e2e4 e7e5 g1f3 b8c6 f1b5 a7a6 b5a4': { eco: 'C70', name: 'Ruy Lopez — Morphy', weight: 90 },
  'e2e4 e7e5 g1f3 b8c6 f1b5 a7a6 b5a4 g8f6 e1g1 f8e7': { eco: 'C78', name: 'Ruy Lopez — Morphy, Closed', weight: 80 },
  'e2e4 e7e5 g1f3 b8c6 f1b5 a7a6 b5a4 g8f6 e1g1 f8e7 f1e1': { eco: 'C78', name: 'Ruy Lopez — Morphy, Re1', weight: 75 },
  'e2e4 e7e5 g1f3 b8c6 f1b5 a7a6 b5a4 g8f6 e1g1 f8e7 f1e1 b7b5': { eco: 'C78', name: 'Ruy Lopez — Morphy, b5', weight: 72 },
  'e2e4 e7e5 g1f3 b8c6 f1b5 a7a6 b5a4 g8f6 e1g1 f8e7 f1e1 b7b5 b5b3': { eco: 'C78', name: 'Ruy Lopez — Morphy, Bb3', weight: 70 },
  'e2e4 e7e5 g1f3 b8c6 f1b5 a7a6 b5a4 g8f6 e1g1 f8e7 f1e1 b7b5 b5b3 d7d6': { eco: 'C78', name: 'Ruy Lopez — Morphy, d6', weight: 68 },
  'e2e4 e7e5 g1f3 b8c6 f1c4 f8c5 c2c3 g8f6': { eco: 'C50', name: 'Giuoco Piano — c3', weight: 88 },
  'e2e4 e7e5 g1f3 b8c6 f1c4 f8c5 c2c3 g8f6 d2d4': { eco: 'C53', name: 'Giuoco Piano — d4', weight: 85 },
  'e2e4 e7e5 g1f3 b8c6 f1c4 f8c5 c2c3 g8f6 d2d4 e5d4': { eco: 'C53', name: 'Giuoco Piano — Open', weight: 82 },
  'e2e4 e7e5 g1f3 b8c6 f1c4 f8c5 c2c3 g8f6 d2d4 e5d4 c3d4': { eco: 'C54', name: 'Giuoco Piano — cxd4', weight: 80 },
  'e2e4 e7e5 g1f3 b8c6 f1c4 f8c5 b2b4': { eco: 'C51', name: 'Evans Gambit', weight: 55 },
  'e2e4 c7c5 g1f3 d7d6 d2d4 c5d4 f3d4 g8f6 b1c3 a7a6': { eco: 'B90', name: 'Sicilian — Najdorf', weight: 85 },
  'e2e4 c7c5 g1f3 d7d6 d2d4 c5d4 f3d4 g8f6 b1c3 a7a6 c1e3': { eco: 'B90', name: 'Sicilian — Najdorf, English Attack', weight: 78 },
  'e2e4 c7c5 g1f3 d7d6 d2d4 c5d4 f3d4 g8f6 b1c3 g7g6': { eco: 'B70', name: 'Sicilian — Dragon', weight: 75 },
  'e2e4 c7c5 g1f3 d7d6 d2d4 c5d4 f3d4 g8f6 b1c3 g7g6 c1e2': { eco: 'B70', name: 'Sicilian — Dragon, Classical', weight: 72 },
  'e2e4 c7c5 g1f3 d7d6 d2d4 c5d4 f3d4 g8f6 b1c3 g7g6 f2f3': { eco: 'B70', name: 'Sicilian — Dragon, Yugoslav', weight: 70 },
  'd2d4 d7d5 c2c4 e7e6 b1c3 g8f6 c1g5': { eco: 'D37', name: "Queen's Gambit Declined — Bg5", weight: 82 },
  'd2d4 d7d5 c2c4 e7e6 g1f3 g8f6 b1c3 f8e7': { eco: 'D37', name: "Queen's Gambit Declined — 3.Nf3", weight: 80 },
  'd2d4 d7d5 c2c4 e7e6 g1f3 g8f6 b1c3 f8e7 c1f4': { eco: 'D37', name: "Queen's Gambit Declined — London hybrid", weight: 75 },
  'd2d4 d7d5 g1f3 g8f6 c1f4': { eco: 'D00', name: 'London System', weight: 90 },
  'd2d4 d7d5 g1f3 g8f6 c1f4 c7c5 e2e3': { eco: 'D00', name: 'London System — c5', weight: 85 },
  'd2d4 d7d5 g1f3 g8f6 c1f4 c7c5 e2e3 b8c6 c2c3': { eco: 'D00', name: 'London System — Nc6', weight: 82 },
  'd2d4 d7d5 g1f3 g8f6 c1f4 e7e6 e2e3 c7c5 c2c3 b8c6': { eco: 'D00', name: 'London System — main line', weight: 80 },
  'e2e4 e7e5 g1f3 b8c6 f1b5 a7a6 b5a4 g8f6': { eco: 'C78', name: 'Ruy Lopez — Morphy', weight: 85 },
  'e2e4 e7e5 g1f3 b8c6 f1c4': { eco: 'C50', name: 'Italian Game', weight: 95 },
  'e2e4 e7e5 g1f3 b8c6 f1c4 f8c5': { eco: 'C50', name: 'Giuoco Piano', weight: 90 },
  'e2e4 e7e5 g1f3 b8c6 f1c4 g8f6': { eco: 'C55', name: 'Two Knights Defence', weight: 85 },
  'e2e4 e7e5 g1f3 d7d6': { eco: 'C41', name: 'Philidor Defence', weight: 60 },
  'e2e4 e7e5 g1f3 g8f6': { eco: 'C42', name: 'Petrov Defence', weight: 70 },
  'e2e4 e7e5 f2f4': { eco: 'C30', name: "King's Gambit", weight: 40 },
  'e2e4 c7c5': { eco: 'B20', name: 'Sicilian Defence', weight: 100 },
  'e2e4 c7c5 g1f3': { eco: 'B27', name: 'Sicilian — 2.Nf3', weight: 95 },
  'e2e4 c7c5 g1f3 d7d6': { eco: 'B50', name: 'Sicilian — 2…d6', weight: 90 },
  'e2e4 c7c5 g1f3 d7d6 d2d4': { eco: 'B54', name: 'Sicilian Open', weight: 95 },
  'e2e4 c7c5 g1f3 d7d6 d2d4 c5d4': { eco: 'B54', name: 'Sicilian Open', weight: 90 },
  'e2e4 c7c5 g1f3 d7d6 d2d4 c5d4 f3d4': { eco: 'B54', name: 'Sicilian Open', weight: 90 },
  'e2e4 c7c5 g1f3 d7d6 d2d4 c5d4 f3d4 g8f6': { eco: 'B56', name: 'Sicilian — Classical path', weight: 80 },
  'e2e4 c7c5 g1f3 e7e6': { eco: 'B40', name: 'Sicilian — 2…e6', weight: 75 },
  'e2e4 c7c5 g1f3 b8c6': { eco: 'B30', name: 'Sicilian — 2…Nc6', weight: 80 },
  'e2e4 c7c5 g1f3 g7g6': { eco: 'B27', name: 'Sicilian — Hyperaccelerated', weight: 50 },
  'e2e4 c7c6': { eco: 'B10', name: 'Caro-Kann Defence', weight: 85 },
  'e2e4 c7c6 d2d4': { eco: 'B12', name: 'Caro-Kann Defence', weight: 90 },
  'e2e4 c7c6 d2d4 d7d5': { eco: 'B12', name: 'Caro-Kann Defence', weight: 95 },
  'e2e4 c7c6 d2d4 d7d5 b1c3': { eco: 'B15', name: 'Caro-Kann — Classical', weight: 70 },
  'e2e4 c7c6 d2d4 d7d5 e4e5': { eco: 'B12', name: 'Caro-Kann — Advance', weight: 75 },
  'e2e4 e7e6': { eco: 'C00', name: 'French Defence', weight: 85 },
  'e2e4 e7e6 d2d4': { eco: 'C00', name: 'French Defence', weight: 90 },
  'e2e4 e7e6 d2d4 d7d5': { eco: 'C01', name: 'French Defence', weight: 95 },
  'e2e4 e7e6 d2d4 d7d5 b1c3': { eco: 'C10', name: 'French — Classical', weight: 80 },
  'e2e4 e7e6 d2d4 d7d5 e4e5': { eco: 'C02', name: 'French — Advance', weight: 75 },
  'e2e4 e7e6 d2d4 d7d5 e4d5': { eco: 'C01', name: 'French — Exchange', weight: 55 },
  'e2e4 g8f6': { eco: 'B02', name: 'Alekhine Defence', weight: 45 },
  'e2e4 d7d5': { eco: 'B01', name: 'Scandinavian Defence', weight: 55 },
  'e2e4 d7d5 e4d5': { eco: 'B01', name: 'Scandinavian Defence', weight: 90 },
  'e2e4 d7d5 e4d5 d8d5': { eco: 'B01', name: 'Scandinavian — 2…Qxd5', weight: 70 },
  'e2e4 d7d5 e4d5 g8f6': { eco: 'B01', name: 'Scandinavian — 2…Nf6', weight: 65 },
  'e2e4 b7b6': { eco: 'B00', name: "Owen's Defence", weight: 25 },
  'e2e4 g7g6': { eco: 'B06', name: 'Modern Defence', weight: 40 },
  'e2e4 d7d6': { eco: 'B07', name: 'Pirc Defence', weight: 50 },
  'e2e4 d7d6 d2d4': { eco: 'B07', name: 'Pirc Defence', weight: 80 },
  'e2e4 d7d6 d2d4 g8f6': { eco: 'B07', name: 'Pirc Defence', weight: 85 },
  'd2d4': { eco: 'A40', name: "Queen's Pawn", weight: 100 },
  'd2d4 d7d5': { eco: 'D00', name: "Queen's Pawn Game", weight: 90 },
  'd2d4 d7d5 c2c4': { eco: 'D06', name: "Queen's Gambit", weight: 100 },
  'd2d4 d7d5 c2c4 e7e6': { eco: 'D30', name: "Queen's Gambit Declined", weight: 90 },
  'd2d4 d7d5 c2c4 e7e6 b1c3': { eco: 'D35', name: "Queen's Gambit Declined", weight: 85 },
  'd2d4 d7d5 c2c4 e7e6 b1c3 g8f6': { eco: 'D37', name: 'QGD', weight: 80 },
  'd2d4 d7d5 c2c4 c7c6': { eco: 'D10', name: 'Slav Defence', weight: 85 },
  'd2d4 d7d5 c2c4 c7c6 b1c3': { eco: 'D10', name: 'Slav Defence', weight: 80 },
  'd2d4 d7d5 c2c4 d5c4': { eco: 'D20', name: "Queen's Gambit Accepted", weight: 60 },
  'd2d4 g8f6': { eco: 'A45', name: 'Indian Defence', weight: 95 },
  'd2d4 g8f6 c2c4': { eco: 'A50', name: 'Indian Defence', weight: 95 },
  'd2d4 g8f6 c2c4 e7e6': { eco: 'E00', name: "Queen's Indian / Nimzo path", weight: 85 },
  'd2d4 g8f6 c2c4 e7e6 b1c3': { eco: 'E20', name: 'Nimzo-Indian path', weight: 90 },
  'd2d4 g8f6 c2c4 e7e6 b1c3 f8b4': { eco: 'E20', name: 'Nimzo-Indian Defence', weight: 95 },
  'd2d4 g8f6 c2c4 e7e6 g1f3': { eco: 'E10', name: 'Indian — 3.Nf3', weight: 75 },
  'd2d4 g8f6 c2c4 g7g6': { eco: 'E60', name: "King's Indian Defence", weight: 90 },
  'd2d4 g8f6 c2c4 g7g6 b1c3': { eco: 'E61', name: "King's Indian Defence", weight: 90 },
  'd2d4 g8f6 c2c4 g7g6 b1c3 f8g7': { eco: 'E61', name: "King's Indian Defence", weight: 85 },
  'd2d4 g8f6 c2c4 c7c5': { eco: 'A56', name: 'Benoni / Benko path', weight: 55 },
  'd2d4 f7f5': { eco: 'A80', name: 'Dutch Defence', weight: 40 },
  'c2c4': { eco: 'A10', name: 'English Opening', weight: 80 },
  'c2c4 e7e5': { eco: 'A20', name: 'English — 1…e5', weight: 75 },
  'c2c4 c7c5': { eco: 'A30', name: 'English — Symmetrical', weight: 70 },
  'c2c4 g8f6': { eco: 'A15', name: 'English — Anglo-Indian', weight: 70 },
  'c2c4 e7e6': { eco: 'A13', name: 'English — 1…e6', weight: 55 },
  'g1f3': { eco: 'A04', name: 'Réti Opening', weight: 70 },
  'g1f3 d7d5': { eco: 'A06', name: 'Réti — 1…d5', weight: 65 },
  'g1f3 g8f6': { eco: 'A05', name: 'Réti — 1…Nf6', weight: 70 },
  'g1f3 c7c5': { eco: 'A04', name: 'Réti — 1…c5', weight: 50 },
  'b2b3': { eco: 'A01', name: 'Nimzo–Larsen Attack', weight: 30 },
  'f2f4': { eco: 'A02', name: "Bird's Opening", weight: 25 },
  'b1c3': { eco: 'A00', name: 'Van Geet Opening', weight: 20 },
};

/**
 * @param {string[]} uciMoves history of UCI moves from start
 * @returns {{ eco: string, name: string, weight?: number } | null}
 */
export function lookupOpening(uciMoves) {
  const fromBin = lookupFromBin(uciMoves);
  if (fromBin) return fromBin;
  if (!Array.isArray(uciMoves) || uciMoves.length === 0) return null;
  const max = Math.min(uciMoves.length, 16);
  let best = null;
  for (let n = 1; n <= max; n += 1) {
    const key = uciMoves.slice(0, n).map((u) => String(u).toLowerCase()).join(' ');
    if (BOOK[key]) best = BOOK[key];
  }
  return best;
}

/**
 * Weighted book reply for computer (polyglot-style / CDB1 when loaded).
 * @param {string[]} uciMoves
 * @returns {string|null} next UCI ply
 */
export function bookReply(uciMoves) {
  const candidates = bookCandidates(uciMoves);
  if (!candidates.length) return null;
  const total = candidates.reduce((s, c) => s + c.weight, 0);
  let r = Math.random() * total;
  for (const c of candidates) {
    r -= c.weight;
    if (r <= 0) return c.uci;
  }
  return candidates[candidates.length - 1].uci;
}

/**
 * Next-move candidates from club book (bin preferred, JS BOOK fallback).
 * @returns {{ uci: string, weight: number, eco?: string, name?: string }[]}
 */
export function bookCandidates(uciMoves) {
  const fromBin = bookCandidatesFromBin(uciMoves);
  if (fromBin?.length) return fromBin;
  if (!Array.isArray(uciMoves)) return [];
  const key = uciMoves.map((u) => String(u).toLowerCase()).join(' ');
  const prefix = key ? `${key} ` : '';
  const depth = uciMoves.length + 1;
  return Object.keys(BOOK)
    .filter((k) => (key ? k.startsWith(prefix) : !k.includes(' ')) && k.split(' ').length === depth)
    .map((k) => ({
      uci: k.split(' ').pop(),
      weight: Math.max(1, BOOK[k].weight || 1),
      eco: BOOK[k].eco,
      name: BOOK[k].name,
    }))
    .sort((a, b) => b.weight - a.weight);
}

/**
 * Prefer a long book line matching ECO (for Explore on profile / coach board).
 * @returns {{ ucis: string[], fen: string, eco: string, name: string } | null}
 */
export function lineForEco(eco) {
  if (!eco) return null;
  const want = String(eco).toUpperCase();
  let bestKey = null;
  let bestMeta = null;
  Object.entries(BOOK).forEach(([key, meta]) => {
    if (String(meta.eco || '').toUpperCase() !== want) return;
    if (!bestKey || key.split(' ').length > bestKey.split(' ').length) {
      bestKey = key;
      bestMeta = meta;
    }
  });
  if (!bestKey || !bestMeta) return null;
  return {
    ucis: bestKey.split(' '),
    eco: bestMeta.eco,
    name: bestMeta.name,
  };
}

/** Prefetch CDB1 binary (safe to call once from Play Hub / game page). */
export function warmOpeningBook() {
  return loadClubBookBin().catch(() => null);
}

/** Exposed for tests / diagnostics. */
export function bookSize() {
  return Object.keys(BOOK).length;
}

/** Top ECO entries for coach board picker (deduped by eco, longest name). */
export function listBookOpenings(limit = 24) {
  const byEco = new Map();
  Object.values(BOOK).forEach((meta) => {
    if (!meta?.eco) return;
    const prev = byEco.get(meta.eco);
    if (!prev || (meta.name || '').length > (prev.name || '').length) {
      byEco.set(meta.eco, { eco: meta.eco, name: meta.name, weight: meta.weight || 0 });
    }
  });
  return [...byEco.values()]
    .sort((a, b) => (b.weight || 0) - (a.weight || 0))
    .slice(0, limit);
}
